import { FormattedMessage } from 'react-intl'

import { Collapse as CollapseMUI } from '@mui/material'

import BurgerSVG from 'app/assets/icons/navigation/burger.svg'
import Box from 'app/components/base/Box'
import type { CollapseProps } from 'app/components/base/Collapse'
import IconButton from 'app/components/base/IconButton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import useBoolean from 'app/hooks/useBoolean'

interface HelpCenterCategoriesCollapseProps
  extends Pick<CollapseProps, 'open'> {}

const HelpCenterCategoriesCollapse: RFC<HelpCenterCategoriesCollapseProps> = ({
  open,
  children
}) => {
  const [isOpen, setOpen] = useBoolean(open)

  return (
    <Box
      sx={{
        border: { xs: '1px solid', md: 'none' },
        borderColor: { xs: 'border.main', md: 'none' },
        borderRadius: 1,
        px: { xs: 2, md: 0 },
        py: { xs: 1.5, md: 0 }
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        onClick={() => setOpen.toggle()}
        sx={{ display: { xs: 'flex', md: 'none' } }}
      >
        <IconButton
          size="small"
          disableRipple
          sx={{ width: 24, height: 24, px: 0 }}
        >
          <BurgerSVG />
        </IconButton>

        <Text variant="body1" sx={{ color: 'primary.main' }}>
          <FormattedMessage defaultMessage="Categories" />
        </Text>
      </Stack>

      <CollapseMUI in={isOpen} timeout="auto" unmountOnExit>
        {children}
      </CollapseMUI>
    </Box>
  )
}

export default HelpCenterCategoriesCollapse
